import logger from '../../../utils/logger';

export default function onError() {
  // TODO: Handle errors
  logger.error('Authentication returned error.');
}
